/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
// import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// About Us page sections

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/front2.jpeg";
import { useTranslation } from "react-i18next";
import MKBadge from "components/MKBadge";
import useDataFetching from "hooks/useDataFetching";
import { config } from "constants/config/config";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Divider, Icon, Slide, TableContainer } from "@mui/material";
import MKAvatar from "components/MKAvatar";
import axios from "axios";
import MKButton from "components/MKButton";
import { Modal, Table } from "react-bootstrap";


function Statistiques() {
    const { t } = useTranslation();
    const [region, setRegion] = useState("*");
    const [statsEnterprises, setStatEnterprises] = useState({});
    const [statExpatGenre, setStatExpatGenre] = useState([]);
    const [statExpatPoste, setStatExpatPoste] = useState([]);
    const [expatsByNationality, setExpatsByNationality] = useState([]);
    const [statsExpats, setStatExpats] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingE, setLoadingE] = useState(false);
    const [loadingEN, setLoadingEN] = useState(false);
    const [loadingES, setLoadingES] = useState(false);
    const [loadingER, setLoadingER] = useState(false);
    const [loadingENR, setLoadingENR] = useState(false);
    const [loadingG, setLoadingG] = useState(false);
    const [loadingP, setLoadingP] = useState(false);
    const [show, setShow] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [row1, setRow1] = useState("");
    const [row2, setRow2] = useState("");
    const [dataModal, setDataModal] = useState([]);
    const [enterpriseStatBySector, setEnterpriseStatBySector] = useState([]);
    const [expatRegions, setExpatRegions] = useState([]);
    const [enterprisesRegions, setEnterprisesRegions] = useState([]);

    // FETCH REGIONS LIST
    const [loadingR, errorR, regions, fetchRegions] = useDataFetching(
        `${config.app.api_url}/regions`
    );

    const [departement, setDepartement] = useState(null);
    const [arrondissement, setArrondissement] = useState(null);

    // FETCH departments by region id
    const [loadingD, errorD, departements] = useDataFetching(
        `${config.app.api_url}/regions/${region !== "*" && region}/departments`
    );

    // FETCH arrondisements by department id
    const [loadingA, errorA, arrondisements] = useDataFetching(
        `${config.app.api_url}/departments/${departement}/arrondissements`
    );

    console.log("error R ", errorR, errorD, errorA, arrondissement, statsEnterprises, statsExpats, expatsByNationality, enterpriseStatBySector, loadingES)

    const fetchStatEnterprises = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoading(true);
        axios
            .get(`${config.app.api_url}/enterprises/stats-details`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setStatEnterprises(res?.data?.data);
                console.log("Enterprises DATA ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ", err);
                setStatEnterprises([]);
            })
            .finally(() => setLoading(false));
    };

    const fetchStatExpatGenre = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoadingG(true);
        axios
            .get(`${config.app.api_url}/employers/stats-by-sexe`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setStatExpatGenre(res?.data?.data);
                console.log("Enterprises DATA ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ", err);
                setStatExpatGenre([]);
            })
            .finally(() => setLoadingG(false));
    };

    const fetchStatExpatPoste = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoadingP(true);
        axios
            .get(`${config.app.api_url}/employers/stats-by-occupation`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setStatExpatPoste(res?.data?.data);
                console.log("Enterprises DATA ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ", err);
                setStatExpatPoste([]);
            })
            .finally(() => setLoadingP(false));
    };

    const fetchStatExpats = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoadingE(true);
        axios
            .get(`${config.app.api_url}/employers/stats-details`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setStatExpats(res?.data?.data);
                console.log("Enterprises DATA ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ", err);
                setStatExpats({});
            })
            .finally(() => setLoadingE(false));
    };

    const fetchExpatByNationality = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoadingEN(true);
        axios
            .get(`${config.app.api_url}/employers/stats-by-nationality`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setExpatsByNationality(res?.data?.data);
                console.log("Enterprises DATA ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ", err);
                setExpatsByNationality([]);
            })
            .finally(() => setLoadingEN(false));
    };

    const fetchEnterpriseBySector = () => {
        const params = {};
        if (region != "*") {
            params.regionId = region;
        }
        if (departement != null) {
            params.departmentId = departement;
        }
        if (arrondissement != null) {
            params.arrondissementId = arrondissement;
        }
        // params.fromArchive = true;
        setLoadingES(true);
        axios
            .get(`${config.app.api_url}/enterprises/stats-by-sector`, { params },
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setEnterpriseStatBySector(res?.data?.data);
                console.log("Enterprises ES ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ES ", err);
                setEnterpriseStatBySector([]);
            })
            .finally(() => setLoadingES(false));
    };

    const handleModal = (title, row1, row2, data) => {
        setModalTitle(title);
        setRow1(row1);
        setRow2(row2);
        setDataModal(data);
        setShow(true);
    };

    const fetchExpatByRegion = () => {
        setLoadingER(true);
        axios
            .get(`${config.app.api_url}/employers/stats-national-regions`,
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setExpatRegions(res?.data?.data);
                console.log("Enterprises ER ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ER ", err);
                setExpatRegions([]);
            })
            .finally(() => setLoadingER(false));
    };

    const fetchEnterprisesByRegion = () => {
        setLoadingENR(true);
        axios
            .get(`${config.app.api_url}/enterprises/stats-national-regions`,
                {
                    headers: {
                        // Authorization: authHeader(),
                    }
                }
            )
            .then((res) => {
                setEnterprisesRegions(res?.data?.data);
                console.log("Enterprises ENR ", res?.data?.data);
            })
            .catch((err) => {
                console.log("Enterprises error ENR ", err);
                setEnterprisesRegions([]);
            })
            .finally(() => setLoadingENR(false));
    };

    useEffect(() => {
        fetchRegions();
    }, []);

    useEffect(() => {
        fetchStatEnterprises();
        fetchStatExpats();
        fetchExpatByNationality();
        fetchEnterpriseBySector();
        fetchExpatByRegion();
        fetchEnterprisesByRegion();
        fetchStatExpatGenre();
        fetchStatExpatPoste();
    }, [region, departement, arrondissement]);



    //FORMATAGE DES SALAIRES
    const formatNumber = (nombre) => {

        if (nombre != null && nombre != undefined) {
            return nombre.toLocaleString('us')
        }
        else {
            return '--'
        }
    }

    return (
        <>
            <DefaultNavbar
                routes={routes}
                sticky={true}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "default",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="45vh"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.6),
                            rgba(gradients.dark.state, 0.6)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        flexDirection="column"
                        sx={{ textAlign: "left" }}
                    >
                        <MKTypography
                            variant="h2"
                            color="white"
                        >
                            {t("Navbar.Services.2")}
                        </MKTypography>
                    </Grid>
                </Container>
            </MKBox>
            <Grid
                sx={{
                    p: 2,
                    mb: 4,
                }}
            >
                <Container>
                    <Grid>
                        <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                overflowX: 'auto', // Permet le défilement horizontal
                                whiteSpace: 'nowrap', // Empêche les éléments de passer à la ligne suivante
                                '&::-webkit-scrollbar': { display: 'none' }, // Cache la scrollbar sur les navigateurs Webkit
                                msOverflowStyle: 'none',  // Cache la scrollbar sur IE et Edge
                                scrollbarWidth: 'none',  // Cache la scrollbar sur Firefox
                                padding: '5px'
                            }}>
                            <MKBadge sx={{
                                cursor: "pointer", // Ajoute le curseur de pointeur
                                "&:hover": {
                                    cursor: "pointer", // Change le curseur lors du survol
                                    boxShadow: 0, // Ajoute une ombre lors du survol pour un effet visuel
                                },
                                margin: '5px', // Ajoute un espace entre chaque élément
                            }} onClick={() => {
                                setRegion("*");
                                setDepartement(null);
                                setArrondissement(null);
                            }} color={region === "*" ? "success" : "light"} circular={true} badgeContent={"National"} container />
                            {
                                !loadingR && regions?.data ? regions?.data.map((item) => (
                                    <MKBadge sx={{
                                        cursor: "pointer", // Ajoute le curseur de pointeur
                                        "&:hover": {
                                            cursor: "pointer", // Change le curseur lors du survol
                                            boxShadow: 0, // Ajoute une ombre lors du survol pour un effet visuel
                                        },
                                        margin: '5px', // Ajoute un espace entre chaque élément
                                    }} onClick={() => {
                                        setRegion(item?.id)
                                        setDepartement(null);
                                        setArrondissement(null);
                                    }} key={item?.id} color={region === item?.id ? "success" : "light"} circular={true} badgeContent={item?.name} container />
                                )) : <></>
                            }
                        </Grid>
                        {!loadingD && <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                overflowX: 'auto', // Permet le défilement horizontal
                                whiteSpace: 'nowrap', // Empêche les éléments de passer à la ligne suivante
                                '&::-webkit-scrollbar': { display: 'none' }, // Cache la scrollbar sur les navigateurs Webkit
                                msOverflowStyle: 'none',  // Cache la scrollbar sur IE et Edge
                                scrollbarWidth: 'none',  // Cache la scrollbar sur Firefox
                                padding: '5px'
                            }}>
                            {
                                departements?.data && departements?.data.map((item) => (
                                    <MKBadge sx={{
                                        cursor: "pointer", // Ajoute le curseur de pointeur
                                        "&:hover": {
                                            cursor: "pointer", // Change le curseur lors du survol
                                            boxShadow: 0, // Ajoute une ombre lors du survol pour un effet visuel
                                        },
                                        margin: '5px', // Ajoute un espace entre chaque élément
                                    }} onClick={() => {
                                        setDepartement(item?.id);
                                        setArrondissement(null);
                                    }} key={item?.id} color={departement === item?.id ? "success" : "light"} circular={true} badgeContent={item?.name} container />
                                ))
                            }
                        </Grid>}
                        {!loadingA && <Grid container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                                overflowX: 'auto', // Permet le défilement horizontal
                                whiteSpace: 'nowrap', // Empêche les éléments de passer à la ligne suivante
                                '&::-webkit-scrollbar': { display: 'none' }, // Cache la scrollbar sur les navigateurs Webkit
                                msOverflowStyle: 'none',  // Cache la scrollbar sur IE et Edge
                                scrollbarWidth: 'none',  // Cache la scrollbar sur Firefox
                                padding: '5px'
                            }}>
                            {
                                arrondisements?.data && arrondisements?.data.map((item) => (
                                    <MKBadge sx={{
                                        cursor: "pointer", // Ajoute le curseur de pointeur
                                        "&:hover": {
                                            cursor: "pointer", // Change le curseur lors du survol
                                            boxShadow: 0, // Ajoute une ombre lors du survol pour un effet visuel
                                        },
                                        margin: '5px', // Ajoute un espace entre chaque élément
                                    }} onClick={() => {
                                        setArrondissement(item?.id)
                                    }} key={item?.id} color={arrondissement === item?.id ? "success" : "light"} circular={true} badgeContent={item?.name} container />
                                ))
                            }
                        </Grid>}
                    </Grid>
                    <Grid container xs={12} md={12} spacing={3} justifyContent="left" textAlign="left">
                        <Grid item xs={12} sm={6} lg={8}>
                            <Grid container direction={"row"}>
                                <MKBox
                                    display={{ xs: "block", md: "flex" }}
                                    variant={"contained"}
                                    mr={5}
                                    borderRadius="xl"
                                    sx={{
                                        backgroundColor: 'rgba(8, 56, 4, 0.57)',
                                    }}
                                    pt={2}
                                    px={2}
                                >
                                    {!loading ? <MKAvatar
                                        display="block"
                                        variant="h3"
                                        color={"white"}
                                        sx={{
                                            backgroundColor: 'rgba(242, 153, 74, 0.20)',
                                        }}
                                        textGradient={"contained"}
                                        mt={-0.625}>
                                        <Icon fontSize="lg">account_balance_icon</Icon>
                                    </MKAvatar> : <CircularProgress color="white" size={24} />}
                                    <MKBox pt={{ xs: 3, md: 0 }} pl={{ xs: 0, md: 2 }} lineHeight={1}>
                                        <MKTypography
                                            display="block"
                                            variant="5"
                                            color={"white"}
                                            fontWeight="bold"
                                            mb={1}
                                        >
                                            {statsEnterprises?.total && formatNumber(statsEnterprises?.total)}
                                        </MKTypography>
                                        <MKTypography
                                            display="block"
                                            variant="body2"
                                            color={"white"}
                                            mb={2}
                                        >
                                            {t("Statistiques.enterprise.title")}
                                        </MKTypography>
                                    </MKBox>
                                </MKBox>
                                <MKBox
                                    display={{ xs: "block", md: "flex" }}
                                    variant={"contained"}
                                    borderRadius="xl"
                                    mr={5}
                                    sx={{
                                        backgroundColor: 'rgba(8, 56, 4, 0.57)',
                                    }}
                                    pt={2}
                                    px={2}
                                >
                                    {!loadingE ? <MKAvatar
                                        display="block"
                                        variant="h3"
                                        color={"white"}
                                        sx={{
                                            backgroundColor: 'rgba(242, 153, 74, 0.20)',
                                        }}
                                        textGradient={"contained"}
                                        mt={-0.625}>
                                        <Icon fontSize="lg">people</Icon>
                                    </MKAvatar> : <CircularProgress color="white" size={24} />}
                                    <MKBox pt={{ xs: 3, md: 0 }} pl={{ xs: 0, md: 2 }} lineHeight={1}>
                                        <MKTypography
                                            display="block"
                                            variant="5"
                                            color={"white"}
                                            fontWeight="bold"
                                            mb={1}
                                        >
                                            {statsExpats?.total && formatNumber(statsExpats?.total)}
                                        </MKTypography>
                                        <MKTypography
                                            display="block"
                                            variant="body2"
                                            color={"white"}
                                            mb={2}
                                        >
                                            {t("Statistiques.expatrie.title")}
                                        </MKTypography>
                                    </MKBox>
                                </MKBox>
                            </Grid>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>
                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.1")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "65%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.6')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.7')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingES ? (
                                                enterpriseStatBySector
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',

                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </TableContainer>
                            </MKBox>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>
                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.3")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "60%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.8')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.9')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingER ? (
                                                expatRegions
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',

                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </TableContainer>
                            </MKBox>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>
                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.15")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "60%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.14')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.9')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingP ? (
                                                statExpatPoste
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',

                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </TableContainer>
                            </MKBox>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>
                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.4")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "95%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.10')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.11')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingEN ? (
                                                expatsByNationality
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' || item?.label == undefined ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </TableContainer>
                            </MKBox>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>

                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.5")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "60%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.8')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.7')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingENR ? (
                                                enterprisesRegions
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' || item?.label == undefined ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </MKBox>
                            <MKBox
                            >
                                <TableContainer
                                    borderRadius="xl"
                                    mr={5}
                                    pt={2}
                                    px={2} sx={{ backgroundColor: 'rgba(8, 56, 4, 0.57)', mt: 2 }}>

                                    <MKTypography
                                        display="block"
                                        variant="5"
                                        sx={{
                                            color: '#FCE410',
                                        }}
                                        fontWeight="bold"
                                        m={1}
                                    >
                                        {t("Statistiques.repartition.12")}
                                    </MKTypography>
                                    <Box
                                        sx={{
                                            top: 0,
                                            width: "60%",
                                            bottom: 0,
                                            left: 0, // Positionner la ligne à gauche
                                            borderTop: '1px solid white', // Définit la ligne verticale
                                        }}
                                    />
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr
                                                style={{
                                                    borderBottom: '1px solid #E2E2E2',
                                                }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.13')}
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right',
                                                        color: '#FFF',
                                                        fontWeight: 'bold',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {t('Statistiques.repartition.9')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loadingG ? (
                                                statExpatGenre
                                                    .sort((a, b) => b.number - a.number)
                                                    .slice(0, 20)
                                                    .map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #E2E2E2',
                                                            }}
                                                        >
                                                            <td
                                                                style={{
                                                                    textAlign: 'left',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {item?.label === '' || item?.label == undefined ? t('Unknown') : item?.label?.toUpperCase()}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: 'right',
                                                                    color: '#FFF',
                                                                    padding: '8px',
                                                                }}
                                                            >
                                                                {formatNumber(item?.number)}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={2} style={{ textAlign: 'center', padding: '8px' }}>
                                                        <CircularProgress color="inherit" size={24} />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <MKButton
                                        color="secondary"
                                        size="small"
                                        // component="a"
                                        onClick={() => {
                                            handleModal(t("Statistiques.repartition.12"), t('Statistiques.repartition.13'), t('Statistiques.repartition.9'), statExpatGenre);
                                        }}
                                        sx={{ mb: 2, alignSelf: 'center', m: 1 }}
                                    >
                                        {t("Actualite.bouton")}
                                    </MKButton>
                                </TableContainer>
                            </MKBox>
                        </Grid>
                    </Grid>
                </Container>
                <Modal open={show} onClose={() => setShow(false)} sx={{ display: "grid", placeItems: "center" }}>
                    <Slide direction="down" in={show} timeout={500}>
                        <MKBox
                            position="relative"
                            width="80%"
                            display="flex"
                            flexDirection="column"
                            borderRadius="xl"
                            bgColor="white"
                            shadow="xl"
                        >
                            <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                                <MKTypography variant="h5">{modalTitle}</MKTypography>
                                <Icon fontSize="medium" sx={{ cursor: "pointer" }} onClick={() => setShow(false)}>close</Icon>
                            </MKBox>
                            <Divider sx={{ my: 0 }} />
                            <MKBox component="section" py={{ xs: 3 }} sx={{ overflow: 'auto' }}>
                                <Table responsive bordered hover size="sm" className="custom-table">
                                    <thead>
                                        <tr style={{ fontSize: "14px" }}>
                                            <th className="text-center" style={{
                                                color: "#0F056B",
                                                textTransform: "uppercase"
                                            }}>{row1}</th>
                                            <th className="text-center" style={{
                                                color: "#0F056B",
                                                textTransform: "uppercase"
                                            }}>{row2}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataModal.map((item, index) => (
                                            <tr style={{
                                                color: "#0F056B",
                                                verticalAlign: "bottom",
                                                fontSize: "12px"
                                            }} key={index}>
                                                <td style={{ color: "#0F056B" }}>{item?.label === '' || item?.label == undefined ? t('Unknown') : item?.label?.toUpperCase()}</td>
                                                <td style={{ color: "#0F056B" }}>{formatNumber(item?.number)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </MKBox>
                            <MKBox display="flex" justifyContent="right" p={1.5}>
                                <MKButton variant="gradient" color="dark" onClick={() => setShow(false)}>
                                    {t("FNTEC.table.enterprise.close")}
                                </MKButton>
                            </MKBox>
                        </MKBox>
                    </Slide>
                </Modal>
            </Grid>
            <MKBox pt={6} px={1} mt={6}>
                <DefaultFooter content={footerRoutes} />
            </MKBox>
        </>
    );
}

export default Statistiques;
